import Image from 'next/image';

import { cn } from '@/lib/utils';
import { Banner } from '@/types/banner';

interface BannerContentProps {
    banner?: Banner;
    titleClassName?: string;
}

export const BannerContent = ({ banner, titleClassName }: BannerContentProps) => {
    return (
        <div className='size-full'>
            <Image
                src={banner?.image || '/images/404.jpg'}
                alt={banner?.title || 'Banner'}
                fill
                className='object-cover'
                priority
                loading='eager'
                sizes='(max-width: 768px) 100vw, (max-width: 1200px) 100vw, 100vw'
                placeholder='blur'
                blurDataURL='data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNzAwIiBoZWlnaHQ9IjQ3NSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB2ZXJzaW9uPSIxLjEiLz4='
            />
            <div className='absolute inset-0 flex items-center justify-center pt-20'>
                <p
                    className={cn(
                        'font-greatVibes z-10 max-w-full px-4 text-center text-[38px] sm:text-[60px] lg:text-[110px] font-normal text-white',
                        titleClassName,
                    )}
                >
                    {banner?.title}
                </p>
            </div>
        </div>
    );
};
